const o = {
  chartContainer: {
    width: "100%",
    borderRadius: "8px",
    position: "relative",
    height: "100%"
  },
  highchartsAxisLine: {
    display: "none"
  },
  xLabelFormat: {
    fontFamily: "satoshi",
    fontSize: "100px",
    fontWeight: 500
  },
  xAxisLabel: {
    fontFamily: "satoshi",
    fontWeight: 500,
    fontSize: "10px",
    color: "#878787"
  },
  tooltipContent: {
    color: "#fff",
    fontFamily: "satoshi",
    fontWeight: 500,
    fontSize: "10px"
  },
  customDiv: {
    border: "1px solid #c5c8ce",
    position: "absolute",
    color: "#141414",
    background: "#ffffff",
    borderRadius: "5px",
    padding: "5px",
    fontSize: "12px",
    fontFamily: "satoshi",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.5s",
    zIndex: 1,
    transform: "translateX(-50%)",
    minWidth: "20px",
    textAlign: "center"
  },
  selectedEvent: {
    background: "#3c3c3c",
    border: "1px solid #3c3c3c",
    color: "#fff"
  }
}, t = {
  ...o.customDiv,
  "&:hover": {
    background: "#EFEFEF",
    border: "1px solid #c5c8ce",
    color: "#141414"
  }
}, e = {
  ...o.selectedEvent,
  "&:hover": {
    background: "#3c3c3c",
    border: "1px solid #3c3c3c",
    color: "#fff"
  }
};
export {
  t as eventDivStyles,
  e as selectedEventStyles,
  o as themeStyles
};
